<template>
	<!-- Material form register -->
	<div id="confirm-signup">
		<!-- <div class="detailView"> -->
		<loading
			:active.sync="isLoading"
			:can-cancel="true"
			:on-cancel="onCancel"
			:is-full-page="fullPage"
		></loading>
		<b-alert
			:show="dismissCountDown"
			dismissible
			variant="danger"
			@dismissed="dismissCountDown = 0"
			@dismiss-count-down="countDownChanged"
			>{{ err }}
		</b-alert>
		<div class="appView">
			<div class="gatekeeperView logIn">
				<div class="gatekeeperContentView">
					<div class="logo"></div>

					<div class="gatekeeperForm">
						<div class="formHeader">
							<div class="title">Welcome back!</div>
							<div class="separator"></div>
						</div>

						<div class="formContent tableView">
							<div class="tableSection sectionCredentials">
								<div class="block inputCell email isDisabled">
									<div class="title">Email</div>
									<div class="input placeholder">
										<input
											v-model="email"
											type="email"
											class="form-control"
											disabled
										/>
									</div>
								</div>

								<div class="block inputCell newPassword">
									<div class="title">Confirm Code</div>
									<div class="input placeholder">
										<input
											v-model="confirmCode"
											type="text"
											name="confirmCode"
											class="form-control password"
										/>
									</div>
								</div>
							</div>

							<div
								class="button buttonLarge"
								:class="[
									!(email || confirmCode) ? 'buttonDisabled' : 'buttonTint'
								]"
							>
								<div
									class="title"
									data-style="slide-left"
									type="submit"
									@click="confirmAccount"
								>
									Confirm
								</div>
							</div>
							<div class="button errorButton" v-show="isError">
								<div class="title" data-style="slide-left" type="submit">
									Couldn't Log in
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="navBar">
              <div class="title">Confirm your account</div>
            </div>
            <br>
            <div class="detailsList">
              <div class="tableSection sectionEmail">
                <div class="block email">
                    <div class="title">Email</div>
                    <div class="detail"><input v-model="email" type="email" class="form-control" disabled/></div>
                </div>
              </div>
              <br>
              <div class="tableSection sectionName">
                <div class="block firstName">
                    <div class="title">Confirmation code</div>
                    <div class="detail"><input v-model="confirmCode" type="text" name="confirmCode" class="form-control"/></div>
                </div>
              </div>
              <br>
              <div class="tableSection sectionName">
                <div class="block firstName">
                    <div class="detail"><button class="btn btn-success" type="submit" @click="confirmAccount">Confirm</button></div>
                </div>
              </div>
            </div> -->
		<!-- </div> -->
	</div>
</template>

<script>
import Auth from "@aws-amplify/auth";
import Amplify from "@aws-amplify/core";
import { AmplifyEventBus } from "aws-amplify-vue";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	name: "ConfirmSignup",
	data() {
		return {
			signedIn: false,
			email: this.$route.query.email,
			confirmCode: "",
			isLoading: false,
			fullPage: true,
			dismissSecs: 5,
			dismissCountDown: 0,
			err: ""
		};
	},
	components: {
		Loading
	},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		confirmAccount() {
			this.isLoading = true;
			setTimeout(() => {
				this.isLoading = false;
			}, 5000);
			// After retrieveing the confirmation code from the user
			Auth.confirmSignUp(this.email, this.confirmCode, {
				// Optional. Force user confirmation irrespective of existing alias. By default set to True.
				forceAliasCreation: true
			})
				.then(data => {
					// console.log(data);
					this.$router.push({ name: "signin", query: { email: this.email } });
				})
				.catch(err => {
					this.isLoading = false;
					console.log(err);
					this.err = err.message;
					this.dismissCountDown = this.dismissSecs;
				});
		}
	}
};
</script>
